import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { LOGOUT } from '../user/actions'

import { SET_VIDEO_PROGRESS } from './actions'

const INITIAL_STATE = 0

export const video = createReducer(INITIAL_STATE, {
  [SET_VIDEO_PROGRESS]: (state, { progress }) => progress,

  [LOGOUT]: () => INITIAL_STATE,
})



// WEBPACK FOOTER //
// ./src/modules/video/reducers.js